import { postApi, putApi, getServiceApi, getNoAuthRFPApi, getApi } from './common/apis';
import axios from 'axios';

export default class AccountMangementService {
    async addNewUser(payload) {
        var userResponse = await postApi(`v1/account`, payload);
        return userResponse;
    }

    async getAccount(accountId) {
        const accountData = await getApi(`v1/account?accountId=${accountId}`);
        return accountData;
    }

    async updateAccredition(payload) {
        const accreditionData = await putApi(`v1/account`, payload);
        return accreditionData;
    }

    async getChannels() {
        const subnetworkData = await getServiceApi(`/api/v1/get-subnetwork`);
        return subnetworkData;
    }

    async getContractTemplate(subnetworkId) {
        const contractTemplateData = await getNoAuthRFPApi(`api/v1/check-channel-template/${subnetworkId}`);
        return contractTemplateData;
    }

    async updateLastLogin(userId) {
        const res = await postApi(`v1/user/update-last-login`, { user_id: userId });
        return res;
    }

    async getPresignedUrl(fileName, contentType) {
        const response = await getApi(`v1/upload-url?is_excel_export=true&file_name=${fileName}&content_type=${contentType}`);
        return response;
    }

    async uploadToS3(presignedUrl, file) {
        const response = await axios.put(presignedUrl, file, {
            headers: {
                'Content-Type': file.type,
            }
        });
        return response;
    }

    async triggerBulkUpload(data) {
        const payload = data.subnetworkId ? {
            key: data.key,
            subnetwork_id: data.subnetworkId
        } : {
            key: data.key
        }
        const response = await postApi(`v1/bulk-partner-create`, payload);
        return response;
    }

    async getPartners(subnetworkId) {
        const response = await getApi(`v1/partner-list?subnetwork_id=${subnetworkId}`);
        return response;
    }

    async searchAllPartners(searchQuery) {
        try {
            // Search across all channels for partners
            const response = await getApi(`v1/partners/search?query=${encodeURIComponent(searchQuery)}`);
            
            // Handle undefined or null response
            if (!response || !response.data) {
                console.warn('API returned undefined or invalid response');
                return {
                    status: 200,
                    data: []
                };
            }
            
            // Transform the response to show only partner names
            const transformedData = response.data.results ? response.data.results.map(partner => ({
                id: partner.account_id,
                name: partner.name,
                account_id: partner.account_id,
                account_type_id: partner.account_type_id,
                is_active: partner.is_active,
                is_production: partner.is_production,
                similarity_score: partner.similarity_score
            })) : [];
            
            return {
                status: response.status || 200,
                data: transformedData
            };
        } catch (error) {
            console.error('Error searching partners:', error);
            return {
                status: 500,
                data: []
            };
        }
    }

    async updatePartnerStatus(payload) {
        const response = await postApi(`v1/partner-list?subnetwork_id=${payload.subnetworkId}`, payload.partners);
        return response;
    }

    async addExistingPartner(payload) {
        const response = await putApi(`v1/update-partner-contacts`, payload);
        return response;
    }

    async getPartnerDistributors(partnerAccountId) {
        const response = await getApi(`v1/partner-distributors?account_id=${partnerAccountId}`);
        return response;
    }

    async checkIfAccountCodeExists(accountCode){
        const response = await getApi(`v1/check-account-exists?accountCode=${accountCode}`);
        return response;
    }

    async getBulkUploadTemplate() {
        const response = await getApi(`v1/s3-signed-url?key=bulk_upload_template.xlsx`);
        return response;
    }
}
